// @flow
import React from 'react';
import CreateAccountValuePropFeatures from 'app/common/react/components/growth/smb/CreateAccountValueProp/CreateAccountValuePropFeatures';
import CreateAccountValuePropStats from 'app/common/react/components/growth/smb/CreateAccountValueProp/CreateAccountValuePropStats';
import type { MultiTreatmentExp } from 'app/common/lib/experiment';

const getEnabledGroup = (valuePropExp: MultiTreatmentExp): string => {
  if (valuePropExp.check('enabled_features_variation')) {
    return 'enabled_features_variation';
  }

  if (valuePropExp.check('enabled_stats_variation')) {
    return 'enabled_stats_variation';
  }

  return '';
};

const renderValuePropComponent = (group: string) => {
  if (group === 'enabled_features_variation') {
    return <CreateAccountValuePropFeatures />;
  } else if (group === 'enabled_stats_variation') {
    return <CreateAccountValuePropStats />;
  } else {
    return null;
  }
};

export default null;

export { getEnabledGroup, renderValuePropComponent };
